import {Message} from 'element-ui'

export default function callInit(ops,callFailF,callConfirmF) {
  if (ops) {
    // let script = document.getElementById('dySdkScript')
    let script = document.createElement('script')
    script.setAttribute('src', 'https://cti.duyansoft.com/syui/dysdk/dysdk2.min.js')
    script.setAttribute('type', 'text/javascript')
    if (ops.dyToken) {
      script.setAttribute('url', `https://cti.duyansoft.com/ctibar.html?account_id=${ops.dyAccountId}&token=${ops.dyToken}&t=${new Date()}`)
    }
    script.setAttribute('ctype', 'mini')
    // script.setAttribute('allow', 'microphone')
    script.setAttribute('id', 'dySdkScript')
    document.getElementById('ctiIframe').appendChild(script)

    script.onload = () => {
      // eslint-disable-next-line no-undef
      const $DYSDK = DYSDK
      $DYSDK.init()
      $DYSDK.ready(() => {
        console.log('ready!!')
        document.getElementById('ctiIframe').firstElementChild.style.height = '100%'
        document.getElementById('dyCti').style.height = '100%'
      })
      // 接通电话的回调函数，返回电话号码等信息
      $DYSDK.callConfirm(function (data) {
        console.log('接通', data)
        callConfirmF(data)
        if (!data.uuid) {
          Message({
            message: '不存在uuid',
            type: 'error',
            duration: 3 * 1000
          })
        }
      })
      // 拨打电话失败的回调函数，返回电话号码等信息
      $DYSDK.callFail(function (data) {
        console.log('callFail:', data)
        callFailF(data)
        // var id = localStorage.getItem('id');
        Message({
          message: '拨打电话失败',
          type: 'error',
          duration: 3 * 1000
        })
        // console.log(id)
        if (!data.uuid) {
          Message({
            message: '不存在uuid',
            type: 'error',
            duration: 3 * 1000
          })
        }
      })
      // 电话结束的回调函数，返回电话号码等信息
      $DYSDK.callEnd(function (data) {
        console.log('callEnd:', data)
        console.log('结束', data)
        if (!data.uuid) {
          Message({
            message: '不存在uuid',
            type: 'error',
            duration: 3 * 1000
          })
        }
      })
      // 正在拨打中的回调函数，返回电话号码等信息
      $DYSDK.callConnecting(function (data) {
        console.log('callConnecting:', data)
        Message({
          message: '电话呼出中',
          type: 'info',
          duration: 3 * 1000
        })
      })
      // 编辑电话记录结束后的回调函数，返回电话号码等信息
      $DYSDK.wrapupEnd(function (data) {
        console.log('wrapupEnd:', data)
        console.log(data)
        if (!data.uuid) {
          Message({
            message: '不存在uuid',
            type: 'error',
            duration: 3 * 1000
          })
        }
      })
      // CTI退出登录的回调函数
      $DYSDK.ctiLogout(function (data) {
        Message({
          message: '自动退出登录，请重新登录',
          type: 'error',
          duration: 3 * 1000
        })
      })
      // 登录成功后返回accountId.
      $DYSDK.ctiLogined(function (data) {
        console.log('登录成功', data)
      })
      $DYSDK.callBridge(function (data) {
        console.log('.CTI处于预测式智能外呼状态', data)
      })
      $DYSDK.getPhonelines(function (data) {
        console.log(data)
      })
    }
  }
}
